module.exports = __webpack_public_path__ + "static/media/img_all.abbe65ff.svg";